<template>
  <OnClickOutside :do="closePanel">
    <div :class="{'h-28': isSticky}">
      <div :class="{'fixed top-0 inset-x-0 z-20 bg-smoke-100 shadow': isSticky}">
        <div
          class="relative md:w-95 mx-auto max-w-max"
          :class="{'pb-8 md:pb-10': !isSticky}"
        >
          <div
            class="flex items-center px-5 py-4 md:px-4 bg-smoke-100 lg:rounded-lg text-17px"
            @click="closePanel"
          >
            <button
              class="hidden lg:flex items-center px-4 py-2 rounded-full"
              :class="{'bg-white': isCategoryPanelOpen}"
              @click.stop="openCategoriesPanel"
            >
              <i class="icon-boxMenu text-blue text-2.5xl"></i>
              <span class="ml-2">Categories</span>
            </button>
            <div class="md:px-5 flex items-center flex-grow">
              <div class="rounded-full border border-smoke-b bg-white px-2 md:px-3 py-2 w-full flex">
                <input
                  class="px-2 flex-grow pt-2px"
                  placeholder="What are you looking for?"
                  v-model="keyword"
                  @keydown.enter.prevent="searchResults"
                >
                <select
                  class="bg-white border-l pl-3 pr-12 hidden lg:block"
                  :class="{'text-gray-400': !selectedCategory}"
                  v-model="selectedCategory"
                >
                  <option value="">All Categories</option>
                  <option
                    v-for="(option, index) in getCategories"
                    :key="`option-${index}`"
                    :value="option.slug"
                    class="text-black p-2"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <button
              class="bg-blue text-white rounded-full ml-2 md:ml-0 px-3 md:px-10 py-3 md:py-2 flex items-center"
              @click="searchResults"
            >
              <span class="hidden lg:block">Search</span>
              <i class="icon-search lg:hidden text-2xl"></i>
            </button>
          </div>
          <div
            class="lg:hidden px-5"
            :class="{'pt-5' :!isSticky}"
            @click="closePanel"
          >
            <div class="rounded-full bg-smoke-100 flex justify-around p-1">
              <button
                class="flex items-center justify-center px-4 py-1 rounded-full w-full"
                :class="{'bg-white': isCategoryPanelOpen}"
                @click.stop="openCategoriesPanel"
              >
                <i class="icon-boxMenu text-blue text-2.5xl"></i>
                <span class="ml-2">Categories</span>
              </button>
            </div>
          </div>
          <transition name="slide-down">
            <CategoriesPanel v-if="isCategoryPanelOpen" @close="closePanel" />
          </transition>
        </div>
      </div>
    </div>
  </OnClickOutside>
</template>
<script>
import { mapGetters } from 'vuex'
import CategoriesPanel from "./CategoriesPanel"

export default {
  name: 'SearchArea',
  props: {
    searched: { type: String, default: '' },
    category: { type: String, default: '' }
  },
  components: { CategoriesPanel },
  data() {
    return {
      selectedCategory: '',
      keyword: this.searched,
      isCategoryPanelOpen: false,
      isSticky: false
    }
  },
  watch: {
    searched(val) { this.keyword = val },
    category() { this.setCategory() },
    '$route'() { this.isCategoryPanelOpen = false }
  },
  mounted () {
    this.setCategory()
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    ...mapGetters ([ 'getCategories' ])
  },
  methods: {
    setCategory() {
      const category = this.category === 'health_' ? 'health_&_wellness' : this.category 
      const exist = this.getCategories.filter(cat => cat.slug === category)
      if (exist.length) this.selectedCategory = category
    },
    searchResults() {
      let path = '/search'
      if (this.selectedCategory && this.keyword) {
        path = `/${this.selectedCategory}?keyword=${this.keyword}`
      }
      else if (!this.selectedCategory && this.keyword) {
        path = `${path}?keyword=${this.keyword}`
      }
      else if (this.selectedCategory && !this.keyword) {
        path = `/${this.selectedCategory}`
      }
      this.$router.push(path)
    },
    openCategoriesPanel() {
      this.isCategoryPanelOpen = !this.isCategoryPanelOpen
    },
    closePanel() {
      this.isCategoryPanelOpen = false
    },
    onScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      this.isSticky = currentScrollPosition > 250 ? true : false
    }
  }
}
</script>
